import { render, staticRenderFns } from "./CalcHeading.vue?vue&type=template&id=f8b86618&"
import script from "./CalcHeading.vue?vue&type=script&lang=js&"
export * from "./CalcHeading.vue?vue&type=script&lang=js&"
import style0 from "./CalcHeading.vue?vue&type=style&index=0&id=f8b86618&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports